import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "antd";
import TextInput from "components/TextInput";
import NumberInput from "components/NonFloatingNumberInput";
import {
  useUpdateBrandSettingsMutation,
} from "redux/settings/settingsSlice";
import { UTILS } from "utils";
import { errorHandler } from "api/api/errorHandler";
import { useSelector } from "react-redux";
import { validateMerchantSavingField } from "utils/Validator";
import AppModal from "components/ui/AppModal";
import AppInput from "components/ui/AppInput";
import AppButton from "components/ui/AppButton";
import AppOutlineButton from "components/ui/AppOutlineButton";


const MerchantSavingBenchmarkModal = ({ merchantSavings, setStats }) => {
  const { t } = useTranslation();
  const { isLoading } = useSelector((state) => state.LoaderReducer);
  const [updateBrandSettings] = useUpdateBrandSettingsMutation();
  const [merchantSavingModal, setMerchantSavingModal] = useState(merchantSavings ?? {});
  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    const updated = { ...merchantSavingModal, [field]: value };
    setMerchantSavingModal(updated);

    const fieldError = validateMerchantSavingField(field, value);
    setErrors((prev) => ({
      ...prev,
      [field]: fieldError[field],
    }));
  };

  const handleClose = ()=>{
    setMerchantSavingModal(null)
    setErrors({})
  }

  const handleUpdate = async (updatePayload, preventValidate=false) => {
    if(!preventValidate){
    const vendorNameErrors = validateMerchantSavingField("vendorName", merchantSavingModal.vendorName);
    const benchmarkErrors = validateMerchantSavingField("vendorBenchmark", merchantSavingModal.vendorBenchmark);
    const allErrors = { ...vendorNameErrors, ...benchmarkErrors };

    setErrors(allErrors);
    if (Object.keys(allErrors).length > 0) return;
    }
    try {
      const userDetail = UTILS.getCurrentUser();
      const payload = {
        brandId: userDetail.brandId,
        merchantSavings: {
          ...merchantSavings,
          ...updatePayload
        }
      }
      delete payload?.isOpen
      await updateBrandSettings(payload).unwrap();
      setStats((prev) => ({ ...prev, merchantSavings: payload?.merchantSavings }))
      handleClose()
    } catch (error) {
      UTILS.errorNotification(errorHandler(error?.error?.message));
    }
  };

  useEffect(() => {
    if (merchantSavings && !merchantSavings?.hidePopup && !merchantSavings?.customBenchmarkProvided && !merchantSavings?.vendorBenchmark) {
      setMerchantSavingModal((prev) => ({ ...prev, ...merchantSavings, isOpen: true }));
    }
  }, [merchantSavings]);


  return (
    <AppModal
      open={merchantSavingModal?.isOpen}
      title="Merchant Saving Benchmark"
      onClose={() => handleClose()}
      footer={<div className="flex justify-end gap-2">
        <AppOutlineButton
          variant="secondary"
          onClick={() =>{
            handleUpdate({
              hidePopup: true
            },true)
            handleClose()
          }}
          disabled={isLoading}
        >
          {t("Hide Popup Forever")}
        </AppOutlineButton>
        <AppButton
          variant="primary"
          onClick={() => handleUpdate({
            ...merchantSavingModal,
            customBenchmarkProvided: true,
            hidePopup: true
          })}
          disabled={isLoading}
        >
          {isLoading ? t("Saving...") : t("Save")}
        </AppButton>
      </div>}
    >
      <AppInput
        type="text"
        label={t("Vendor Name")}
        mandatory={true}
        value={merchantSavingModal?.vendorName}
        error={errors.vendorName ? t(errors.vendorName) : null}
        onInput={(e) => handleChange("vendorName", e.target.value)}
      />
      <div className="mt-4">
        <AppInput
          type="number"
          label={t("Vendor Benchmark")}
          mandatory={true}
          value={merchantSavingModal?.vendorBenchmark}
          error={errors.vendorBenchmark ? t(errors.vendorBenchmark) : null}
          onInput={(e) => handleChange("vendorBenchmark", e.target.value)}
        />
      </div>
    </AppModal>
  );
};

export default MerchantSavingBenchmarkModal;
